import type { z } from './zod';

export interface EventDef<P extends z.ZodTypeAny = z.ZodTypeAny> {
  /** domain.entity.verb in the past tense, e.g. time.entry.created. */
  type: string;
  version: number;
  payload: P;
  /** Aggregate type for outbox_events.aggregate_type, e.g. time_entry. Defaults to the entity segment. */
  aggregateType?: string;
}

export type EventDefinition<P extends z.ZodTypeAny = z.ZodTypeAny> = Required<EventDef<P>>;

const typePattern = /^[a-z][a-zA-Z0-9]*\.[a-z][a-zA-Z0-9]*\.[a-z][a-zA-Z0-9]*$/;

export function defineEvent<P extends z.ZodTypeAny>(def: EventDef<P>): EventDefinition<P> {
  if (!typePattern.test(def.type)) throw new Error(`Event type ${def.type} must be domain.entity.verb`);
  if (!Number.isInteger(def.version) || def.version < 1)
    throw new Error('Event version must be a positive integer');
  return { ...def, aggregateType: def.aggregateType ?? def.type.split('.')[1]! };
}
